<template>
  <div class="swiper-card card-auth">
    <div class="corner-radius-blur"></div>
    <transition name="slide" mode="out-in">
      <div v-if="isWorking" class="working">
        <span class="fetching"></span>
        <span class="message">Just a second</span>
      </div>

      <div v-else-if="state === 'email'" class="form-section" key="email">
        <div class="onboarding-content">
          <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.4025 8.69893L35.2871 7.8902C35.0467 6.21567 33.7196 4.90268 32.0271 4.66482L31.2098 4.55065C29.95 4.36987 29.0749 3.21863 29.248 1.96273C29.4211 0.706823 30.5943 -0.149474 31.8637 0.0217855L32.6811 0.135958C36.4026 0.659251 39.3259 3.56115 39.8644 7.24322L39.9798 8.05195C40.1625 9.29834 39.2874 10.4591 38.0181 10.6399C36.7487 10.8206 35.5852 9.95483 35.4025 8.69893ZM9.99621 8.82261C11.7175 7.11954 14.2082 6.6343 16.3622 7.37642C16.6603 6.72944 17.0738 6.13004 17.6123 5.59723C20.0164 3.21863 23.911 3.21863 26.3151 5.59723L37.6911 16.8433V16.358C37.6911 12.9994 40.451 10.2688 43.8456 10.2688C47.2401 10.2688 50 12.9994 50 16.358V31.3623C50 31.5145 50 31.6572 49.9904 31.8094C49.9904 31.8665 50 31.9141 50 31.9712C50 42.4275 41.4703 50.9239 30.9117 51H30.8636H30.1327C25.0361 51 20.1414 48.9925 16.5353 45.4246L5.64003 34.6542C3.23596 32.2756 3.23596 28.4223 5.64003 26.0437C6.01507 25.6726 6.42857 25.3587 6.8613 25.1018L6.72667 24.9686C4.3226 22.59 4.3226 18.7366 6.72667 16.358C7.26519 15.8252 7.87101 15.4161 8.52492 15.1212C7.78447 12.9899 8.26528 10.5257 9.9866 8.82261H9.99621ZM17.6219 14.2173L17.6123 14.2078L15.439 12.0575C14.8428 11.4676 13.862 11.4676 13.2658 12.0575C12.6695 12.6474 12.6695 13.6179 13.2658 14.2078L15.4294 16.3485L15.439 16.358L24.6899 25.5109C25.5938 26.4052 25.5938 27.8514 24.6899 28.7363C23.786 29.6211 22.3243 29.6306 21.43 28.7363L12.1887 19.5929L12.1791 19.5834C11.5829 18.9935 10.602 18.9935 10.0058 19.5834C9.40962 20.1733 9.40962 21.1438 10.0058 21.7337L13.8043 25.4919L13.8139 25.5014L19.2567 30.8865C20.1606 31.7809 20.1606 33.2271 19.2567 34.1119C18.3528 34.9968 16.8911 35.0063 15.9968 34.1119L11.1117 29.2786L11.1021 29.2691C10.5059 28.6792 9.52501 28.6792 8.9288 29.2691C8.33259 29.859 8.33259 30.8294 8.9288 31.4193L19.7952 42.1992C22.5359 44.9108 26.2574 46.4331 30.1327 46.4331H30.854C38.8162 46.3855 45.2688 40.0489 45.3842 32.1805C45.3746 32.0854 45.3746 31.9807 45.3746 31.8855C45.3842 31.7143 45.3842 31.543 45.3842 31.3623V16.358C45.3842 15.5208 44.6918 14.8357 43.8456 14.8357C42.9993 14.8357 42.307 15.5208 42.307 16.358V22.3616C42.307 23.2845 41.7492 24.1218 40.8838 24.4738C40.0183 24.8259 39.0278 24.6356 38.3643 23.9791L23.0551 8.82261C22.4589 8.23272 21.4781 8.23272 20.8819 8.82261C20.2857 9.41251 20.2857 10.3735 20.8722 10.9729L30.1231 20.1257C31.0271 21.0201 31.0271 22.4663 30.1231 23.3511C29.2192 24.236 27.7575 24.2455 26.8632 23.3511L17.6219 14.2078V14.2173ZM1.97622 38.0794C3.23596 37.8987 4.40915 38.7645 4.59186 40.0204L4.70725 40.8291C4.94766 42.5036 6.27471 43.8166 7.96718 44.0545L8.78456 44.1687C10.0443 44.3494 10.9194 45.5007 10.7463 46.7566C10.5732 48.0125 9.4 48.8688 8.13065 48.6975L7.31327 48.5833C3.59176 48.0505 0.668407 45.1581 0.139511 41.4761L0.024115 40.6673C-0.158595 39.421 0.716488 38.2602 1.98584 38.0794H1.97622Z" fill="#FFDE00"/>
          </svg>
          <div class="onboarding-inner-content">
            <h3>What's your email?</h3>
            <p>Just a quick step so we can get you going with Nourish.</p>
          </div>
        </div>

        <form @submit.prevent="email()">
          <input type="email" id="email" v-model="form.email" autocomplete="email" placeholder="Email">
          <button :disabled="!validation.email" type="submit">Next</button>
        </form>
      </div>

      <div v-else-if="state === 'auth'" class="form-section" key="auth">
        <div class="onboarding-content">
          <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.4025 8.69893L35.2871 7.8902C35.0467 6.21567 33.7196 4.90268 32.0271 4.66482L31.2098 4.55065C29.95 4.36987 29.0749 3.21863 29.248 1.96273C29.4211 0.706823 30.5943 -0.149474 31.8637 0.0217855L32.6811 0.135958C36.4026 0.659251 39.3259 3.56115 39.8644 7.24322L39.9798 8.05195C40.1625 9.29834 39.2874 10.4591 38.0181 10.6399C36.7487 10.8206 35.5852 9.95483 35.4025 8.69893ZM9.99621 8.82261C11.7175 7.11954 14.2082 6.6343 16.3622 7.37642C16.6603 6.72944 17.0738 6.13004 17.6123 5.59723C20.0164 3.21863 23.911 3.21863 26.3151 5.59723L37.6911 16.8433V16.358C37.6911 12.9994 40.451 10.2688 43.8456 10.2688C47.2401 10.2688 50 12.9994 50 16.358V31.3623C50 31.5145 50 31.6572 49.9904 31.8094C49.9904 31.8665 50 31.9141 50 31.9712C50 42.4275 41.4703 50.9239 30.9117 51H30.8636H30.1327C25.0361 51 20.1414 48.9925 16.5353 45.4246L5.64003 34.6542C3.23596 32.2756 3.23596 28.4223 5.64003 26.0437C6.01507 25.6726 6.42857 25.3587 6.8613 25.1018L6.72667 24.9686C4.3226 22.59 4.3226 18.7366 6.72667 16.358C7.26519 15.8252 7.87101 15.4161 8.52492 15.1212C7.78447 12.9899 8.26528 10.5257 9.9866 8.82261H9.99621ZM17.6219 14.2173L17.6123 14.2078L15.439 12.0575C14.8428 11.4676 13.862 11.4676 13.2658 12.0575C12.6695 12.6474 12.6695 13.6179 13.2658 14.2078L15.4294 16.3485L15.439 16.358L24.6899 25.5109C25.5938 26.4052 25.5938 27.8514 24.6899 28.7363C23.786 29.6211 22.3243 29.6306 21.43 28.7363L12.1887 19.5929L12.1791 19.5834C11.5829 18.9935 10.602 18.9935 10.0058 19.5834C9.40962 20.1733 9.40962 21.1438 10.0058 21.7337L13.8043 25.4919L13.8139 25.5014L19.2567 30.8865C20.1606 31.7809 20.1606 33.2271 19.2567 34.1119C18.3528 34.9968 16.8911 35.0063 15.9968 34.1119L11.1117 29.2786L11.1021 29.2691C10.5059 28.6792 9.52501 28.6792 8.9288 29.2691C8.33259 29.859 8.33259 30.8294 8.9288 31.4193L19.7952 42.1992C22.5359 44.9108 26.2574 46.4331 30.1327 46.4331H30.854C38.8162 46.3855 45.2688 40.0489 45.3842 32.1805C45.3746 32.0854 45.3746 31.9807 45.3746 31.8855C45.3842 31.7143 45.3842 31.543 45.3842 31.3623V16.358C45.3842 15.5208 44.6918 14.8357 43.8456 14.8357C42.9993 14.8357 42.307 15.5208 42.307 16.358V22.3616C42.307 23.2845 41.7492 24.1218 40.8838 24.4738C40.0183 24.8259 39.0278 24.6356 38.3643 23.9791L23.0551 8.82261C22.4589 8.23272 21.4781 8.23272 20.8819 8.82261C20.2857 9.41251 20.2857 10.3735 20.8722 10.9729L30.1231 20.1257C31.0271 21.0201 31.0271 22.4663 30.1231 23.3511C29.2192 24.236 27.7575 24.2455 26.8632 23.3511L17.6219 14.2078V14.2173ZM1.97622 38.0794C3.23596 37.8987 4.40915 38.7645 4.59186 40.0204L4.70725 40.8291C4.94766 42.5036 6.27471 43.8166 7.96718 44.0545L8.78456 44.1687C10.0443 44.3494 10.9194 45.5007 10.7463 46.7566C10.5732 48.0125 9.4 48.8688 8.13065 48.6975L7.31327 48.5833C3.59176 48.0505 0.668407 45.1581 0.139511 41.4761L0.024115 40.6673C-0.158595 39.421 0.716488 38.2602 1.98584 38.0794H1.97622Z" fill="#FFDE00"/>
          </svg>
          <div class="onboarding-inner-content">
            <h3>
              {{ isReset ? `Set a new password`
                : hasAccount ? 'Welcome back!'
                : `Get started with Nourish`
              }}
            </h3>
            <p>
              {{ isReset ? `Update your password to something memorable - you'll use this next time.` 
                : hasAccount ? 'Go ahead and enter your password to jump back in.'
                : `Let us know who you are and choose a password.`
              }}
            </p>
          </div>
        </div>

        <div v-if="!isReset && hasAccount" class="otp">
          <button @click="resetPassword()">Email One-Time Login Code</button>

          <div class="break-spacer">
            <span class="space-text">or</span>
          </div>
        </div>

        <form @submit.prevent="auth()">
          <div class="field-stack">
            <input v-if="!hasAccount && !isReset" type="text" id="firstName" v-model="form.firstName" autocomplete="given-name" placeholder="First name">
            <input v-if="!hasAccount && !isReset" type="text" id="lastName" v-model="form.lastName" autocomplete="family-name" placeholder="Last name">
          </div>

          <div class="input-wrapper">
            <input class="hidden-faux-email" type="email" name="username" v-model="form.email" autocomplete="email">
            <input :type="showPassword ? 'text' : 'password'" id="password" v-model="form.password" :autocomplete="hasAccount ? 'current-password' : 'new-password'" :placeholder="hasAccount ? 'Password' : 'Create a password'"/>
            <svg class="pwd-showhide-icon" v-if="showPassword" @click="showPassword = false" width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.39458 0.179494C1.02083 -0.108787 0.478171 -0.0419899 0.183483 0.323635C-0.111204 0.68926 -0.042923 1.22012 0.330827 1.5084L21.6058 17.8209C21.9796 18.1092 22.5222 18.0424 22.8169 17.6768C23.1116 17.3111 23.0433 16.7803 22.6696 16.492L18.889 13.5951C20.3121 12.1678 21.2752 10.5682 21.7604 9.43262C21.879 9.15488 21.879 8.84551 21.7604 8.56778C21.2249 7.3127 20.1 5.48457 18.4182 3.95879C16.7291 2.41895 14.404 1.1252 11.5002 1.1252C9.04927 1.1252 7.00801 2.04981 5.41598 3.2627L1.39458 0.179494ZM8.01786 5.25606C8.93427 4.43692 10.1597 3.9377 11.5002 3.9377C14.3572 3.9377 16.6752 6.20528 16.6752 9.0002C16.6752 9.87559 16.4488 10.6982 16.0499 11.4154L14.6627 10.3537C14.9646 9.6752 15.0436 8.89824 14.8352 8.12832C14.4363 6.66934 13.1174 5.68848 11.6511 5.62871C11.4427 5.62168 11.3205 5.84317 11.3852 6.04004C11.4607 6.26504 11.5038 6.5041 11.5038 6.75371C11.5038 7.11231 11.4175 7.44981 11.2666 7.74863L8.02145 5.25957L8.01786 5.25606ZM13.4049 13.7076C12.8155 13.9361 12.1722 14.0627 11.5002 14.0627C8.64317 14.0627 6.3252 11.7951 6.3252 9.0002C6.3252 8.75762 6.34317 8.52207 6.37551 8.29004L2.98661 5.67793C2.16723 6.72207 1.58145 7.7627 1.24005 8.56778C1.12145 8.84551 1.12145 9.15488 1.24005 9.43262C1.77551 10.6877 2.90036 12.5158 4.58223 14.0416C6.2713 15.5814 8.59645 16.8752 11.5002 16.8752C13.218 16.8752 14.731 16.4217 16.0355 15.7326L13.4049 13.7076Z" fill="black"/>
            </svg>
            <svg class="pwd-showhide-icon" v-else @click="showPassword = true" width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0001 0.125C7.19455 0.125 4.94803 1.41875 3.31261 2.95859C1.68761 4.48438 0.600803 6.3125 0.0869141 7.56758C-0.0276693 7.84531 -0.0276693 8.15469 0.0869141 8.43242C0.600803 9.6875 1.68761 11.5156 3.31261 13.0414C4.94803 14.5812 7.19455 15.875 10.0001 15.875C12.8057 15.875 15.0522 14.5812 16.6876 13.0414C18.3126 11.5121 19.3994 9.6875 19.9168 8.43242C20.0314 8.15469 20.0314 7.84531 19.9168 7.56758C19.3994 6.3125 18.3126 4.48438 16.6876 2.95859C15.0522 1.41875 12.8057 0.125 10.0001 0.125ZM5.00011 8C5.00011 6.65734 5.52689 5.36967 6.46458 4.42027C7.40226 3.47087 8.67403 2.9375 10.0001 2.9375C11.3262 2.9375 12.598 3.47087 13.5356 4.42027C14.4733 5.36967 15.0001 6.65734 15.0001 8C15.0001 9.34266 14.4733 10.6303 13.5356 11.5797C12.598 12.5291 11.3262 13.0625 10.0001 13.0625C8.67403 13.0625 7.40226 12.5291 6.46458 11.5797C5.52689 10.6303 5.00011 9.34266 5.00011 8ZM10.0001 5.75C10.0001 6.99102 9.00358 8 7.77789 8C7.53136 8 7.29525 7.95781 7.07303 7.88398C6.88205 7.8207 6.65983 7.94023 6.66678 8.14414C6.67719 8.38672 6.71191 8.6293 6.77789 8.87187C7.25358 10.6719 9.08344 11.7406 10.8612 11.259C12.639 10.7773 13.6946 8.92461 13.2189 7.12461C12.8334 5.66563 11.5591 4.68477 10.1425 4.625C9.94108 4.61797 9.82303 4.83945 9.88553 5.03633C9.95844 5.26133 10.0001 5.50039 10.0001 5.75Z" fill="black"/>
            </svg>
          </div>

          <label v-if="!hasAccount && !isReset" class="custom-checkbox">
            <input type="checkbox" v-model="form.terms" />
            <span class="checkmark"></span>
            <p>I'm onboard with the <a href="https://nourished.news/privacy" target="_blank">privacy</a> and <a href="https://nourished.news/terms" target="_blank">terms</a>.</p>
          </label>

          <div v-if="!validation.field" class="error-message">
            <span>Uh oh, your first or last name doesn't look quite right.</span>
          </div>

          <button :disabled="!validation.field" type="submit">Next</button>
        </form>

        <!-- <button v-if="!isReset && hasAccount" class="ghost" @click="resetPassword()">I've forgotten my password</button> -->
        <button v-if="isReset || !hasAccount" class="ghost" @click="generatePassword()">Generate a secure password for me</button>
      </div>

      <div v-else-if="state === 'reset'" class="form-section" key="reset">
        <div class="onboarding-content">
          <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.4025 8.69893L35.2871 7.8902C35.0467 6.21567 33.7196 4.90268 32.0271 4.66482L31.2098 4.55065C29.95 4.36987 29.0749 3.21863 29.248 1.96273C29.4211 0.706823 30.5943 -0.149474 31.8637 0.0217855L32.6811 0.135958C36.4026 0.659251 39.3259 3.56115 39.8644 7.24322L39.9798 8.05195C40.1625 9.29834 39.2874 10.4591 38.0181 10.6399C36.7487 10.8206 35.5852 9.95483 35.4025 8.69893ZM9.99621 8.82261C11.7175 7.11954 14.2082 6.6343 16.3622 7.37642C16.6603 6.72944 17.0738 6.13004 17.6123 5.59723C20.0164 3.21863 23.911 3.21863 26.3151 5.59723L37.6911 16.8433V16.358C37.6911 12.9994 40.451 10.2688 43.8456 10.2688C47.2401 10.2688 50 12.9994 50 16.358V31.3623C50 31.5145 50 31.6572 49.9904 31.8094C49.9904 31.8665 50 31.9141 50 31.9712C50 42.4275 41.4703 50.9239 30.9117 51H30.8636H30.1327C25.0361 51 20.1414 48.9925 16.5353 45.4246L5.64003 34.6542C3.23596 32.2756 3.23596 28.4223 5.64003 26.0437C6.01507 25.6726 6.42857 25.3587 6.8613 25.1018L6.72667 24.9686C4.3226 22.59 4.3226 18.7366 6.72667 16.358C7.26519 15.8252 7.87101 15.4161 8.52492 15.1212C7.78447 12.9899 8.26528 10.5257 9.9866 8.82261H9.99621ZM17.6219 14.2173L17.6123 14.2078L15.439 12.0575C14.8428 11.4676 13.862 11.4676 13.2658 12.0575C12.6695 12.6474 12.6695 13.6179 13.2658 14.2078L15.4294 16.3485L15.439 16.358L24.6899 25.5109C25.5938 26.4052 25.5938 27.8514 24.6899 28.7363C23.786 29.6211 22.3243 29.6306 21.43 28.7363L12.1887 19.5929L12.1791 19.5834C11.5829 18.9935 10.602 18.9935 10.0058 19.5834C9.40962 20.1733 9.40962 21.1438 10.0058 21.7337L13.8043 25.4919L13.8139 25.5014L19.2567 30.8865C20.1606 31.7809 20.1606 33.2271 19.2567 34.1119C18.3528 34.9968 16.8911 35.0063 15.9968 34.1119L11.1117 29.2786L11.1021 29.2691C10.5059 28.6792 9.52501 28.6792 8.9288 29.2691C8.33259 29.859 8.33259 30.8294 8.9288 31.4193L19.7952 42.1992C22.5359 44.9108 26.2574 46.4331 30.1327 46.4331H30.854C38.8162 46.3855 45.2688 40.0489 45.3842 32.1805C45.3746 32.0854 45.3746 31.9807 45.3746 31.8855C45.3842 31.7143 45.3842 31.543 45.3842 31.3623V16.358C45.3842 15.5208 44.6918 14.8357 43.8456 14.8357C42.9993 14.8357 42.307 15.5208 42.307 16.358V22.3616C42.307 23.2845 41.7492 24.1218 40.8838 24.4738C40.0183 24.8259 39.0278 24.6356 38.3643 23.9791L23.0551 8.82261C22.4589 8.23272 21.4781 8.23272 20.8819 8.82261C20.2857 9.41251 20.2857 10.3735 20.8722 10.9729L30.1231 20.1257C31.0271 21.0201 31.0271 22.4663 30.1231 23.3511C29.2192 24.236 27.7575 24.2455 26.8632 23.3511L17.6219 14.2078V14.2173ZM1.97622 38.0794C3.23596 37.8987 4.40915 38.7645 4.59186 40.0204L4.70725 40.8291C4.94766 42.5036 6.27471 43.8166 7.96718 44.0545L8.78456 44.1687C10.0443 44.3494 10.9194 45.5007 10.7463 46.7566C10.5732 48.0125 9.4 48.8688 8.13065 48.6975L7.31327 48.5833C3.59176 48.0505 0.668407 45.1581 0.139511 41.4761L0.024115 40.6673C-0.158595 39.421 0.716488 38.2602 1.98584 38.0794H1.97622Z" fill="#FFDE00"/>
          </svg>
          <div class="onboarding-inner-content">
            <h3>Check your email</h3>
            <p>We've sent a 6 digit code to {{ form.email }}. Grab the code and enter it below. It may take up to a minute to arrive.</p>
          </div>
        </div>

        <div class="countdown">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.7812 6.5C11.7812 7.90067 11.2248 9.24398 10.2344 10.2344C9.24398 11.2248 7.90067 11.7812 6.5 11.7812C5.09933 11.7812 3.75602 11.2248 2.76559 10.2344C1.77517 9.24398 1.21875 7.90067 1.21875 6.5C1.21875 5.09933 1.77517 3.75602 2.76559 2.76559C3.75602 1.77517 5.09933 1.21875 6.5 1.21875C7.90067 1.21875 9.24398 1.77517 10.2344 2.76559C11.2248 3.75602 11.7812 5.09933 11.7812 6.5ZM0 6.5C0 8.22391 0.68482 9.87721 1.90381 11.0962C3.12279 12.3152 4.77609 13 6.5 13C8.22391 13 9.87721 12.3152 11.0962 11.0962C12.3152 9.87721 13 8.22391 13 6.5C13 4.77609 12.3152 3.12279 11.0962 1.90381C9.87721 0.68482 8.22391 0 6.5 0C4.77609 0 3.12279 0.68482 1.90381 1.90381C0.68482 3.12279 0 4.77609 0 6.5ZM5.89062 3.04688V6.5C5.89062 6.70312 5.99219 6.89355 6.1623 7.00781L8.5998 8.63281C8.8791 8.8207 9.25742 8.74453 9.44531 8.4627C9.6332 8.18086 9.55703 7.80508 9.2752 7.61719L7.10938 6.175V3.04688C7.10938 2.70918 6.8377 2.4375 6.5 2.4375C6.1623 2.4375 5.89062 2.70918 5.89062 3.04688Z" fill="black"/>
          </svg>
          <span v-if="resetCountdown > 0" class="count">{{ resetCountdown }} {{ resetCountdown | plural('seconds') }}</span>
          <span v-else class="count">Check email</span>
        </div>

        <form @submit.prevent="checkResetCode()">
          <div class="code">
            <input type="number" v-model="form.reset" inputmode="numeric" pattern="[0-9]*" onwheel="return false;" autocomplete="one-time-code" placeholder="000000" maxlength="6"/>
          </div>

          <button type="submit">Next</button>
        </form>
      </div>
    </transition>

    <div v-if="responseErrorMessage" class="error-message">
      <span>{{ responseErrorMessage }}</span>
    </div>

    <!-- <h4>Almost there</h4>
    <h3>{{ state === 'sign-up' ? `Let's get you started` : 'Sign back into Nourish' }}</h3>

    <div class="error-message" v-if="responseErrorMessage">
      {{ responseErrorMessage }}
    </div>

    <form v-if="!isWorking" @submit.prevent="auth()">
      <div class="name-group">
        <input v-show="state === 'sign-up'" type="text" id="firstName" v-model="form.firstName" placeholder="First name">
        <input v-show="state === 'sign-up'" type="text" id="lastName" v-model="form.lastName" placeholder="Last name">
      </div>
      <input type="email" id="email" v-model="form.email" placeholder="Email">
      <input type="password" id="password" v-model="form.password" :placeholder="state === 'sign-up' ? 'Create a password' : 'Password'">

      <label v-show="state === 'sign-up'" class="custom-checkbox">
        <input type="checkbox" v-model="form.terms" />
        <span class="checkmark"></span>
        <p>I'm onboard with the <a href="https://nourished.news/privacy" target="_blank">privacy</a> and <a href="https://nourished.news/terms" target="_blank">terms</a>.</p>
      </label>

      <label v-show="isInvited" class="custom-checkbox">
        <input type="checkbox" v-model="form.public_invite" />
        <span class="checkmark"></span>
        <p>Show @{{ isInvited }} you accepted their invitation.</p>
      </label>

      <button type="submit">{{ state === 'sign-up' ? 'Sign up' : 'Sign in' }}</button>
    </form>-->

    <!--
    <div class="stack" v-show="!isWorking">
      <span class="micro" v-if="state === 'sign-up'">
        Already have an account? <button class="ghost" @click="switchState()">Login</button>
      </span>

      <span class="micro" v-show="state === 'sign-in'">
        New to Nourish? <button class="ghost" @click="switchState()">Sign up</button>
      </span>  
    </div> -->
  </div>
</template>

<script>
  import API from "app/axios.js";
  // import Fetching from '@/components/v5/Fetching.vue';

  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    data() {
      return {
        state: 'email',
        hasAccount: false,
        isReset: false,
        showPassword: false,
        form: {
          // dryrun: (process.env.NODE_ENV == 'development'),
          terms: true,
          public_invite: true,
        },
        resetCountdown: 60,
        lock: null,
        isWorking: false,
        responseErrorMessage: null,
        validation: {
          email: false,
          field: true,
        }
      }
    },

    computed: {
      hasCompletedOnboarding() {
        return this.$userEngine.getOnboardMemo()?.['invited_by'] ? true : false;
      }
    },
    
    // components: {
    //   Fetching,
    // },

    // mounted() {
    //   const state = this.$route.query.n;
    //   if (state) {
    //     if (state !== 'invite') {
    //       this.state = state;
    //     }
    //   }

    //   // defaults
    //   if (this.state == 'sign-up') {
    //     // this.form.terms = true;
    //     if (this.isInvited) {
    //       this.form.public_invite = true;
    //     }
    //   }
    // },

    // computed: {
    //   isInvited() {
    //     return this.$userEngine.getOnboardMemo()?.['invited_by'];
    //   }
    // },

    methods: {
      async email() {
        this.responseErrorMessage = null;
        this.isWorking = true;

        await API.post(`/account/otp`, {
          email: this.form.email,
          exists: 'on',
          memo: JSON.stringify(this.$userEngine.getOnboardMemo())
        }).then((response) => {
          if (response.data.status === 'okay') {
            this.hasAccount = true;
            this.state = 'auth';
          } else if (response.data.reason === 'user-unknown') {
            if (this.hasCompletedOnboarding) {
              this.hasAccount = false;
              this.state = 'auth';
            } else {
              this.EventBus.$emit('swiper:close');
              this.EventBus.$emit('modal:nourish-appflow');
            }
          } else {
            this.responseErrorMessage = `Uh oh. That didn't go to plan. We're looking into it.`
          }
        }).catch(() => {
          this.responseErrorMessage = `Uh oh. That didn't go to plan. We're looking into it.`
        });

        this.isWorking = false;
      },

      async auth() {
        this.responseErrorMessage = null;
        this.isWorking = true;

        if (this.hasAccount) {
          // Sign in
          await API.post(`/account/login`, {
            email: this.form.email,
            password: this.form.password,
            // public_invite: true,
            // memo: JSON.stringify(this.$userEngine.getOnboardMemo())
          }).then((response) => {
            if(response.status.toString().substring(0,1) == 2) {
              this.$store.commit("updateAccount", response.data);
              this.EventBus.$emit("appCallback", {
                type: 'authCallback',
                data: response.data.token
              });
              // reset the homepage, scroll up etc.
              // console.log(`AUTHED -- running home:reset`);
              this.EventBus.$emit('home:reset', 'Auth');
            } else {
              this.responseErrorMessage = `Sorry. Something went wrong. Please try again.`;
            }
            // console.log(`AUTHED -- next()`);
            this.next()
          }).catch((error) => {
            if (error.response.status === 400) {
              this.responseErrorMessage = `Are you sure that password is right?`;
            } else {
              this.responseErrorMessage = `Sorry. Something went wrong. Please try again.`;
            }
          });
        } else if (this.isReset) {
          // Reset the password
          await API.post(`/account/otp`, {
            email: this.form.email,
            password: this.form.password,
            lock: this.lock,
            // public_invite: true,
            // memo: JSON.stringify(this.$userEngine.getOnboardMemo())
          }).then((response) => {
            // console.log('RES', response)
            if(response.status.toString().substring(0,1) == 2) {
              this.$store.commit("updateAccount", response.data);
              this.EventBus.$emit("appCallback", {
                type: 'authCallback',
                data: response.data.token
              });
            } else {
              this.responseErrorMessage = `Sorry. Something went wrong. Please try again.`;
            }
            this.next()
          }).catch(() => {
            this.responseErrorMessage = `Sorry. Something went wrong. Please try again.`;
          });
        } else {

          // Create a new user
          await API.post(`/account`, {
            memo: JSON.stringify(this.$userEngine.getOnboardMemo()),
            ...this.form
          }).then((response) => {   
            if (response.status.toString().substring(0,1) == 2) { // 2xx - success
              this.$store.commit("updateAccount", response.data);
            }

            // Record the current build
            window._os_build = response.data?.build?.client;
            window._os_user = response.data;
            console.log(`Created user at build: ${window._os_build}; `, window._os_user);
            
            // Plausible tracking: (User account created)
            this.EventBus.$emit('track:event', {
              label: 'SignUp: Nourish',
              once: true, // default
            });

            // reset the homepage, scroll up etc.
            setTimeout(() => {
              this.EventBus.$emit('home:reset', 'N2 Signup');
            }, 1000);

            this.next();
          }).catch((error) => {
            this.handleResponseError(error);
          });
        }

        this.isWorking = false;
      },

      async resetPassword() {
        this.responseErrorMessage = null;
        this.isWorking = true;

        await API.post(`/account/otp`, {
          email: this.form.email,
          new: 'on',
        }).then(() => {
          this.startCountdown();
          this.state = 'reset';
        }).catch(() => {
          this.responseErrorMessage = `Sorry. Something went wrong. Please try again.`;
        });

        this.isWorking = false;
      },

      startCountdown() {
        this.resetCountdown = 60;
        if (this._resetInterval) clearInterval(this._resetInterval);
        this._resetInterval = setInterval(() => {
          if (this.resetCountdown > 0) {
            this.resetCountdown--;
          } else {
            clearInterval(this._resetInterval);
            this._resetInterval = null;
          }
        }, 1000);
      },

      async checkResetCode() {
        this.responseErrorMessage = null;
        this.isWorking = true;

        await API.post(`/account/otp`, {
          email: this.form.email,
          otp: this.form.reset,
        }).then((response) => {
          if (response.data.status === 'okay') {
            this.lock = response.data.lock;
            this.hasAccount = false;
            this.isReset = true;
            this.state = 'auth';
          } else {
            this.responseErrorMessage = `Are you sure that code is correct?`
          }
        }).catch(() => {
          this.responseErrorMessage = `Sorry. Something went wrong. Please try again.`;
        });

        this.isWorking = false;
      },

      generatePassword() {
        const length = 20;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+{}[]<>?";
        let password = '';

        for (let i = 0; i < length; i++) {
          const randomIndex = Math.floor(Math.random() * charset.length);
          password += charset[randomIndex];
        }

        this.form.password = password;
        this.showPassword = true;
      },

      isValidName(name) {
        if (name.includes('@')) {
          return false
        }
        return true
      },

      isValidEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      },

      next() {
        this.$emit('next')
      },

      // switchState() {
      //   switch (this.state) {
      //     case 'sign-up':
      //       this.state = 'sign-in';
      //       this.$emit('swiperUpdate');
      //       break
      //     case 'sign-in':
      //       this.state = 'sign-up'
      //       this.$emit('swiperUpdate');
      //       break
      //     default:
      //       this.state = 'sign-up'
      //       this.$emit('swiperUpdate')
      //   }
      // },

      handleResponseError(error) {
        if (!error.response.data.error || !error.response.data.error?.reason) {
          this.responseErrorMessage = `Sorry, something went wrong. We're looking into it. Please try again.`;
          return;
        }

        switch (error.response.data.error.reason) {
          case 'exists':
            this.responseErrorMessage = `It looks like you're already signed up. Please sign in.`;
            break;
          case 'email':
            this.responseErrorMessage = `That email address doesn't seem valid. Please check it and try again.`;
            break;
          case 'password-length':
            this.responseErrorMessage = `We couldn't accept that password.  Please provide a password at least 10 characters long.`;
            break;
          case 'missing-fields':
            this.responseErrorMessage = 'It looks like some information was missing. Please check and try again.';
            break;
          case 'dryrun':
            this.responseErrorMessage = `[TESTING] :: Dry-Run Mode - Nothing saved.`;
            break;
          default:
            this.responseErrorMessage = `Sorry, something went wrong. Please try again.`;
            break;
        }
      },

      

      // auth() {
      //   this.isWorking = true;
      //   this.responseErrorMessage = null;
        
      //   // add the onboarding memo.. 
        // let oPayload = {
        //   memo: JSON.stringify(this.$userEngine.getOnboardMemo()),
        //   ...this.form,
        // };

      //   if (this.state === 'sign-up') {
          // API.post(`/account`, oPayload).then((response) => {   
          //   if (response.status.toString().substring(0,1) == 2) { // 2xx - success
          //     this.$store.commit("updateAccount", response.data);
          //     this.$userEngine.clearOnboardMemo();
          //   }
            
          //   // Plausible tracking: (User account created)
          //   this.EventBus.$emit('track:event', {
          //     label: 'SignUp: Nourish',
          //     once: true, // default
          //   });

          //   this.isWorking = false;
          //   this.next();
          // }).catch((error) => {
          //   this.isWorking = false;
          //   this.handleResponseError(error);
          // });
      //   } else if (this.state === 'sign-in') {
      //     API.post(`/account/login`, oPayload).then((response) => {  
            // if(response.status.toString().substring(0,1) == 2) {
            //   this.$store.commit("updateAccount", response.data);
            //   this.$userEngine.clearOnboardMemo();

            //   this.EventBus.$emit("appCallback", {
            //     type: 'authCallback',
            //     data: response.data.token
            //   });
    
            // } else {
            //   this.responseErrorMessage = `Sorry. Something went wrong. Please try again.`;
            // }

      //       this.next();
      //       this.isWorking = false;
      //     }).catch((error) => {
      //       this.isWorking = false;
            // if (error.response.status === 400) {
            //   this.responseErrorMessage = `Are those details correct? We can't find that account.`;
            // } else {
            //   this.responseErrorMessage = `Sorry. Something went wrong. Please try again.`;
            // }
      //     });
      //   }
      // },
    },

    watch: {
      state() {
        this.$emit('swiperUpdate')
      },

      '$route.params.stack': {
        handler(slug) {
          if (slug === this.slide.slug) {
            this.EventBus.$emit('tab:hide-next', true)
          } else {
            this.EventBus.$emit('tab:hide-next', false)
          }
        },
        immediate: true,
      },

      'form.firstName'(newVal) {
        this.validation.field = this.isValidName(newVal);
      },

      'form.lastName'(newVal) {
        this.validation.field = this.isValidName(newVal);
      },

      'form.email'(newVal) {
        this.validation.email = this.isValidEmail(newVal);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-auth {
    min-height: 30rem;
    max-width: 450px;
    margin: 0 auto;
    padding: 2rem 0;

    .onboarding-content {
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2rem;

      .desktop & {
        align-items: center;
        margin-top: 2rem;
      }

      .onboarding-inner-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
        max-width: 450px;
        margin: 0 auto;

        .desktop & {
          align-items: center;
          text-align: center;
        }
      }

      svg path {
        fill: $yellow-tone-4;

        .darkmode & {
          fill: $yellow-tone-3;
        }
      }
    }

    h3 {
      font-family: 'Brawler';
      font-weight: normal;
      font-size: 38px;
      line-height: 110%;
      text-align: left;
      text-wrap: balance;

      .desktop & {
        font-size: 50px;
        text-align: center;
      }
    }

    p {
      font-size: 20px;
      line-height: 150%;
      text-wrap: balance;
    }

    .stack {
      margin-top: 1rem;
      font-size: 14px;
      padding-top: 1.5rem;
      border-top: 1px solid rgba($neutral-400, 0.25);
      color: $neutral-400;

      .ghost {
        font-size: 14px;
        font-weight: normal;
        color: $neutral-100;
        border-bottom: 1px solid $neutral-400;
        border-radius: 0;
        padding-bottom: 0.25rem;

        .darkmode & {
          color: $neutral-600;
        }

        &:hover {
          border-bottom: 1px solid $neutral-100;

          .darkmode & {
            border-bottom: 1px solid $neutral-600;
          }
        }
      }
    }
  }

  .error-message {
    padding: 1rem 0;
    color: $red-tone-3;
    text-align: center;

    .darkmode & {
      color: $red-tone-2;
    }
  }

  form {
    margin-top: 1rem;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;

    input {
      display: flex;
      align-items: center;
      padding: 1.2rem 1.2rem 1rem 1.2rem;
      border-radius: 10px;
      border: none;
      font-size: 16px;
      margin-bottom: 0.5rem;
      background: rgba($neutral-100, 0.05);

      .darkmode & {
        background: rgba($neutral-600, 0.05);
      }

      &::placeholder {
        color: rgba($neutral-100, 0.6);

        .darkmode & {
          color: rgba($neutral-600, 0.6);
        }
      }
    }

    button {
      margin: 1rem 0;
      width: 100%;

      &:hover {
        transform: scale(1.0);
      }
    }

    .name-group {
      display: flex;
      gap: 0.5rem;
    }

    .custom-checkbox {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      user-select: none;
      font-family: sans-serif;
      font-size: 16px;
      margin: 0.5rem 0;

      p {
        font-family: 'Circular';
        font-weight: normal;
        font-size: 14px;
        padding-bottom: 12px;

        .desktop & {
          padding-bottom: 0;
        }
      }
    }

    .custom-checkbox input {
      position: absolute;
      opacity: 0;
      pointer-events: none;
    }

    .custom-checkbox .checkmark {
      width: 35px;
      height: 35px;
      border-radius: 10px;
      margin-right: 0.75rem;
      display: inline-block;
      position: relative;
      transition: all 0.2s ease;
      background: rgba($neutral-100, 0.05);

      .darkmode & {
        background: rgba($neutral-600, 0.05);
      }
    }

    .custom-checkbox input:checked + .checkmark {
      background-color: $yellow-tone-3;
    }

    .custom-checkbox .checkmark::after {
      content: '';
      position: absolute;
      display: none;
      left: 14px;
      top: 8px;
      width: 5px;
      height: 13px;
      border: solid $neutral-100;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }

    .custom-checkbox input:checked + .checkmark::after {
      display: block;
    }
  }

  .error-message {
    padding: 1.5rem 0;

    span {
      line-height: 150%;
    }
  }

  .working {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;

    .message {
      margin-top: 1rem;
    }

    .fetching {
      display: inline-block;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      animation: rotate 1s linear infinite;

      &:before {
        content: "";
        box-sizing: border-box;
        position: absolute;
        inset: 0px;
        border-radius: 50%;
        animation: prixClipFix 2s linear infinite;
        border: 4px solid $neutral-100;

        .darkmode & {
          border: 4px solid $neutral-600;
        }
      }
    }
  }

  .form-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 10;

    .otp {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 400px;
      margin: 2rem auto 0 auto;

      button {
        margin-top: 0.5rem;
        height: 55px;
        border-radius: 10px;
        font-size: 1rem;
        padding-top: 0.8rem;
        width: 100%;
      }

      .break-spacer {
        width: 100%;
        display: flex;
        align-items: center;
        padding-top: 1.5rem;

        .space-text {
          display: flex;
          align-items: center;
          width: 100%;
          text-align: center;
          color: rgba($neutral-400, 0.5);

          &::before,
          &::after {
            content: '';
            flex: 1;
            height: 1px;
            margin-top: 2px;
            background-color: rgba($neutral-400,0.5);
          }

          &::before {
            margin-right: 1rem;
          }

          &::after {
            margin-left: 1rem;
          }
        }
      }
    }

    .countdown {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 1rem;

      svg {
        margin-right: 0.5rem;

        path {
          fill: $green-tone-3;
        }
      }

      .count {
        font-weight: bold;
        color: $green-tone-3;
        text-align: center;
      }
    }

    form {
      margin-top: 2rem;

      button {
        margin-top: 0.5rem;
        height: 55px;
        border-radius: 10px;
        font-size: 1rem;
        padding-top: 0.8rem;

        &:disabled {
          // background: rgba($neutral-400, 0.1);
          // color: rgba($neutral-400, 0.5);
          background: rgba($neutral-100, 0.05);
          color: rgba($neutral-100, 0.6);

          .darkmode & {
            background: rgba($neutral-600, 0.05);
            color: rgba($neutral-600, 0.6);
          }
        }
      }

      .code {
        display: flex;

        input {
          text-align: center;
          border: none;
          box-shadow: unset;
          border: 1px solid transparent;
          padding: 1rem 0;
          letter-spacing: 1rem;

          &:focus {
            border: 1px solid $yellow-tone-3;
          }
        }
      }

      .field-stack {
        display: flex;
        flex-direction: row;
        gap: 0.5rem;
      }

      .input-wrapper {
        display: flex;
        align-items: center;
        padding-right: 1.2rem;
        border-radius: 10px;
        border: none;
        font-size: 16px;
        margin-bottom: 0.5rem;
        background: rgba($neutral-100, 0.05);

        .darkmode & {
          background: rgba($neutral-600, 0.05);
        }

        .hidden-faux-email {
          position:absolute;
          left: -99999px;
          top: -99999px;
        }

        .pwd-showhide-icon {
          width: 2em;
          margin-left: 1em;
        }

        input {
          border: 0;
          margin: 0;
          font-size: 1rem;
          background: transparent;

          &:focus {
            border: none;
            box-shadow: unset;
            outline: none;
          }
        }

        span {
          margin-bottom: 1px;
        }

        svg {
          path {
            fill: rgba($neutral-400, 0.5);
          }
        }
      }
    }

    .ghost {
      align-self: center;
      text-align: center;
      font-size: 0.9rem;
      font-weight: normal;
      padding: 1rem 0 4px 0;
      border-radius: 0;
      color: $neutral-400;
      border-bottom: 1px solid $neutral-400;

      &:hover {
        color: $neutral-100;
        border-bottom: 1px solid $neutral-100;

        .darkmode & {
          color: $neutral-600;
          border-bottom: 1px solid $neutral-600;
        }
      }
    }
  }

  .slide-enter-active, .slide-leave-active {
    transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
  }

  .slide-enter, .slide-leave-to {
    transform: translateX(100%);
  }

  .slide-leave, .slide-enter-to {
    transform: translateX(0%);
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes prixClipFix {
    0% {
      clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
    75% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }
    100% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
  }
</style>